import type { SpacingToken } from '@/styles/tokens'

export type Side = 'top' | 'bottom' | 'inline-start' | 'inline-end'
export type Placement = Side | `${Side}-start` | `${Side}-end`
export type SpaceStep = Extract<SpacingToken, `space-${string}`>

const SIDES: readonly string[] = ['top', 'bottom', 'inline-start', 'inline-end']

export function toSideAlign(p: Placement): {
  side: Side
  align: 'start' | 'center' | 'end'
} {
  for (const align of ['start', 'end'] as const) {
    const suffix = `-${align}`
    if (p.endsWith(suffix)) {
      const rest = p.slice(0, -suffix.length)
      if (SIDES.includes(rest)) return { side: rest as Side, align }
    }
  }
  return { side: p as Side, align: 'center' }
}

/** A `sideOffset` that reads a spacing token at open time, never a literal. */
export function spaceOffset(step: SpaceStep): () => number {
  return () => {
    const root = document.documentElement
    const raw = getComputedStyle(root).getPropertyValue(`--${step}`).trim()
    const value = Number.parseFloat(raw)
    if (Number.isNaN(value)) return 0
    if (raw.endsWith('rem')) {
      return value * Number.parseFloat(getComputedStyle(root).fontSize)
    }
    if (raw.endsWith('px')) return value
    return 0
  }
}
